module.exports = __webpack_public_path__ + "media/images/icon-svg/profile-e5c2a91d896c680684e1decd5c97d7a8.svg";